import { authFetch } from './authFetch';

export interface KarmaStatus {
  user: string;
  reward_points: number;
  punishment_points: number;
  tally: number;
  updated_at: string;
}

const API_URL = '/api/karma/';

export async function fetchKarmaStatus(token: string): Promise<KarmaStatus> {
  const res = await authFetch(API_URL, {}, token);
  if (!res.ok) throw new Error('Failed to fetch karma status');
  return res.json();
}

export async function updateKarmaStatus(
  token: string,
  updates: Partial<Pick<KarmaStatus, 'reward_points' | 'punishment_points' | 'tally'>>
): Promise<KarmaStatus> {
  const res = await authFetch(
    API_URL,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updates),
    },
    token
  );
  if (!res.ok) throw new Error('Failed to update karma status');
  return res.json();
}
